/**
 * @generated SignedSource<<3e5e2347552a410588bac5edb9e1320b>>
 * @relayHash 156fa367b4e74e9034bf37b73b787887
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/563.0.0-2026-06-09T16:12:07.373Z/RelatedPhotosRendererQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RelatedPhotosRendererQuery$variables = {
  hasUserId: boolean;
  room?: ReadonlyArray<string> | null;
  style?: ReadonlyArray<string> | null;
  userId?: string | null;
};
export type RelatedPhotosRendererQuery$data = {
  readonly viewer: {
    readonly photosSearchBrowseQuery: {
      readonly facets: {
        readonly imageRoomTypeFacet: ReadonlyArray<{
          readonly label: string | null;
          readonly name: string | null;
        } | null> | null;
        readonly imageStyleFacet: ReadonlyArray<{
          readonly label: string | null;
          readonly name: string | null;
        } | null> | null;
      } | null;
      readonly numberOfPages: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"RelatedPhotosGrid_photos">;
    } | null;
  };
};
export type RelatedPhotosRendererQuery = {
  response: RelatedPhotosRendererQuery$data;
  variables: RelatedPhotosRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "room"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "style"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 60
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": 0
  },
  {
    "kind": "Variable",
    "name": "room",
    "variableName": "room"
  },
  {
    "kind": "Variable",
    "name": "style",
    "variableName": "style"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfPages",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RelatedPhotosRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "PhotosSearchBrowseQueryConnection",
            "kind": "LinkedField",
            "name": "photosSearchBrowseQuery",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PhotosSearchBrowseFacets",
                "kind": "LinkedField",
                "name": "facets",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacetValueType",
                    "kind": "LinkedField",
                    "name": "imageStyleFacet",
                    "plural": true,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacetValueType",
                    "kind": "LinkedField",
                    "name": "imageRoomTypeFacet",
                    "plural": true,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RelatedPhotosGrid_photos"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RelatedPhotosRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "PhotosSearchBrowseQueryConnection",
            "kind": "LinkedField",
            "name": "photosSearchBrowseQuery",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PhotosSearchBrowseFacets",
                "kind": "LinkedField",
                "name": "facets",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacetValueType",
                    "kind": "LinkedField",
                    "name": "imageStyleFacet",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacetValueType",
                    "kind": "LinkedField",
                    "name": "imageRoomTypeFacet",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhotosSearchBrowseQueryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhotosSearchBrowsePhoto",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "serviceId",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "path",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhotoLike",
                        "kind": "LinkedField",
                        "name": "photoLike",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "hasUserId",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "userId",
                                    "variableName": "userId"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "photoLikeId",
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPhotoLikes",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/563.0.0-2026-06-09T16:12:07.373Z/RelatedPhotosRendererQuery",
    "metadata": {},
    "name": "RelatedPhotosRendererQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8d35b598ba52c585d7b27371f93b49eb";

export default node;
